import React from "react";
import {Link} from "react-router-dom";
import {
  AdminIcon,
  AllItemsIcon,
  AvatarIcon,
  AvatarShareIcon,
  AvatarTalkIcon,
  AvatarTeachIcon,
  BrowseFriendsIcon,
  ContactIcon,
  ExploreIcon,
  FavoriteIcon,
  FindFriendsIcon,
  FolderIcon,
  HelpIcon,
  ImportIcon,
  InterviewIcon,
  JournalPostIcon,
  LinkIcon,
  LogoutIcon,
  MultiUserMindfileIcon,
  PendingItemsIcon,
  PhotoBoothIcon,
  SettingsIcon,
  SocialIcon,
  SocialNetworkIcon,
  Spacecast2Icon,
  SpacecastAboutIcon,
  SpacecastIcon,
  SpacecastStatsIcon,
  SurveyAttemptIcon,
  UploadIcon
} from '../../../helpers/Icons'

export const siteNav = [
  {
    key:"explore",
    icon:<ExploreIcon />,
    label: 'Explore',
    defaultPath:"/explore/items",
    children:[
      {
        path:"/explore/items",
        default: true,
        icon: <AllItemsIcon />,
        label: 'My Mindfile',
      },
      {
        path:"/explore/pending",
        icon: <PendingItemsIcon />,
        label: 'Pending Items',
        enabled: "edit",
      },
      {
        path:"/explore/folders",
        paths:["/explore/folder"],
        icon: <FolderIcon />,
        label: 'Folders',
      },
      {
        path:"/explore/uploads",
        icon: <UploadIcon />,
        label: 'Files',
      },
      {
        path:"/explore/profile",
        icon: <SurveyAttemptIcon />,
        label: 'Profile',
      },
      {
        path:"/explore/journal",
        icon: <JournalPostIcon />,
        label: 'Journal',
      },
      {
        path:"/explore/links",
        icon: <LinkIcon />,
        label: 'Links',
      },
      {
        path:"/explore/favorites",
        icon: <FavoriteIcon />,
        label: 'Favorites',
      },
      {
        path:"/explore/photo-booth",
        icon: <PhotoBoothIcon />,
        label: 'Photo Booth',
      },
      {
        path:"/explore/imports",
        icon: <ImportIcon />,
        label: 'Import',
        enabled: "user_role",
        role: "import_tester",
      },
    ]
  },
  {
    key:"avatar",
    icon: <AvatarIcon />,
    label: 'Avatar',
    enabled: "avatar",
    defaultPath:"/avatar/talk",
    children:[
      {
        path:"/avatar/talk",
        icon: <AvatarTalkIcon />,
        label: 'Talk',
      },
      {
        path:"/avatar/interview",
        icon: <InterviewIcon />,
        enabled: "avatar",
        label: 'Interview',
      },
      {
        path:"/avatar/share",
        icon: <AvatarShareIcon />,
        label: 'Share',
      },
      {
        path:"/avatar/teach",
        icon: <AvatarTeachIcon />,
        label: 'Talk and Teach',
      },
    ],
  },
  {
    key:"social",
    icon: <SocialIcon />,
    label: 'Social',
    defaultPath:"/social/find-friends",
    children:[
      {
        path:"/social/find-friends",
        icon: <FindFriendsIcon />,
        label: 'Find Friends',
        enabled: "owner",
      },
      {
        path:"/social/browse-friends",
        icon: <BrowseFriendsIcon />,
        label: 'Browse Friends',
      },
      {
        path:"/social/social-network",
        icon: <SocialNetworkIcon />,
        label: 'Social Network',
      },
      {
        path:"/social/multi-user-mindfiles",
        icon: <MultiUserMindfileIcon />,
        label: 'Multi User Mindfiles',
      },
    ],
  },
  {
    key:"spacecast",
    icon:<SpacecastIcon />,
    label: 'Spacecast',
    defaultPath:"/spacecast/about",
    children:[
      {
        path:"/spacecast/about",
        icon: <SpacecastAboutIcon />,
        label: 'about',
      },
      {
        path:"/spacecast/personal-stats",
        icon: <SpacecastStatsIcon />,
        label: 'personal stats',
      },
      {
        path:"/spacecast/personal-log",
        icon: <Spacecast2Icon />,
        label: 'personal log',
      },
      {
        path:"/spacecast/global-log",
        icon: <SpacecastIcon />,
        label: 'global log',
      },
    ],
  },
  {
    key:"admin",
    icon: <AdminIcon />,
    label: 'Admin',
    defaultPath:"/admin/usage-table",
    enabled: 'admin',
    children:[
      {
        path:"/admin/usages",
        icon: null,
        label: 'usage stats',
      },
      {
        path:"/admin/usage-table",
        icon: null,
        label: 'usage table',
      },
      {
        path:"/admin/site",
        icon: null,
        label: 'site stats',
      },
      {
        path:"/admin/users",
        icon: null,
        label: 'mindfile stats',
      },
      {
        path:"/admin/files",
        icon: null,
        label: 'file stats',
      },
      {
        path:"/admin/manage",
        icon: null,
        label: 'manage mindfiles',
      },
      {
        path:"/admin/current",
        icon: null,
        label: 'current mindfile',
      },
    ],

  },
  {
    key:"settings",
    itemProps:{
      component:Link,
      to:"/settings"
    },
    icon: <SettingsIcon />,
    label: 'Settings',
    defaultPath:"/explore/items",
  },
  {
    key:"help",
    itemProps:{ component:'a', href:"#help_load" },
    icon: <HelpIcon />,
    label: 'Help',
  },
  {
    key:"contact",
    icon: <ContactIcon />,
    label: 'Contact',
  },
  {
    key:"logout",
    itemProps:{
      component:Link,
      to:"/logout"
    },
    icon:<LogoutIcon />,
    label: 'Logout',
  },
];